import "core-js/modules/es.array.concat.js";
import { service } from './service'; // 获取送货单List

export function LoadData(data) {
  return service({
    url: 'DeliveryNote/LoadData',
    data: data,
    method: 'post'
  });
} // 获取送货单明细

export function GetDetailList(query) {
  return service({
    url: 'DeliveryNote/GetDetailList',
    params: query,
    method: 'get'
  });
} // 获取供应商列表

export function GetImsVendorLoadData(query) {
  return service({
    url: 'ImsVendor/LoadData',
    params: query,
    method: 'get'
  });
} // 保存送货单

export function saveOrderInfo(data) {
  return service({
    url: 'DeliveryNote/SaveData',
    data: data,
    method: 'post'
  });
} // 查询ERP采购订单明细数据

export function GetErpPoList(query) {
  return service({
    url: 'ScmErpPo/GetErpPoList',
    // url: 'DeliveryNote/GetErpPoList',
    method: 'get',
    params: query
  });
} // 审核送货单

export function AuditOrder(data) {
  return service({
    url: 'DeliveryNote/CheckBill',
    method: 'post',
    data: data
  });
} // 反审核

export function UnCheckBillOrder(data) {
  return service({
    url: 'DeliveryNote/UnCheckBill',
    method: 'post',
    data: data
  });
} // 作废

export function CancelBill(data) {
  return service({
    url: 'DeliveryNote/CancelBill',
    method: 'post',
    data: data
  });
} // 导出送货单list

export function ExportListData(data) {
  return service({
    url: 'DeliveryNote/ExportListData',
    method: 'post',
    data: data
  });
} // 状态转在途

export function PrintBill(data) {
  return service({
    url: 'DeliveryNote/PrintBill',
    method: 'post',
    data: data
  });
} // 导出送货单明细

export function ExportDetailData(_ref) {
  var ID = _ref.ID,
      ORGANIZE_ID = _ref.ORGANIZE_ID,
      EXPORT_FILE_NAME = _ref.EXPORT_FILE_NAME;
  return service({
    url: "DeliveryNote/ExportDetailData?MST_ID=".concat(ID, "&ORGANIZE_ID=").concat(ORGANIZE_ID, "&EXPORT_FILE_NAME=").concat(EXPORT_FILE_NAME),
    method: 'get'
  });
} // 下一张

export function GetLastById(params) {
  return service({
    url: 'DeliveryNote/GetLastById',
    method: 'get',
    params: params
  });
} // 上一张

export function GetNextById(params) {
  return service({
    url: 'DeliveryNote/GetNextById',
    method: 'get',
    params: params
  });
} // 获取送货单供应商邮箱

export function GetVendorEmail(params) {
  return service({
    url: 'DeliveryNote/GetVendorEmail',
    method: 'get',
    params: params
  });
}